import React, { useState, useEffect } from 'react';
import CookieConsent from './CookieConsent';
import CookiePreferences from './CookiePreferences';
import CookieManager from '../utils/cookieManager';

const CookieManagerComponent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);

  useEffect(() => {
    // Controlla se deve mostrare il banner
    if (CookieManager.shouldShowBanner()) {
      // Piccolo delay per permettere al sito di caricarsi
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1500);
      return () => clearTimeout(timer);
    } else {
      // Se il consenso è già stato dato, inizializza i servizi
      initializeServices();
    }
  }, []);

  const initializeServices = () => {
    // Inizializza Google Analytics se consentito
    if (CookieManager.isEnabled('analytics')) {
      // Sostituisci con il tuo ID di misurazione GA4
      CookieManager.initializeGoogleAnalytics('G-XXXXXXXXXX');
    }

    // Inizializza Google Tag Manager se consentito
    if (CookieManager.isEnabled('marketing')) {
      // Sostituisci con il tuo Container ID GTM
      CookieManager.initializeGoogleTagManager('GTM-XXXXXXX');
    }

    // Pulisci cookie non consentiti
    CookieManager.clearNonEssentialCookies();
  };

  const handleBannerClose = () => {
    setShowBanner(false);
    initializeServices();
  };

  const handleOpenPreferences = () => {
    setShowBanner(false);
    setShowPreferences(true);
  };

  const handleClosePreferences = () => {
    setShowPreferences(false);
    initializeServices();
  };

  return (
    <>
      {showBanner && (
        <CookieConsent 
          onClose={handleBannerClose}
          onOpenPreferences={handleOpenPreferences}
        />
      )}
      
      <CookiePreferences 
        isOpen={showPreferences}
        onClose={handleClosePreferences}
      />
    </>
  );
};

export default CookieManagerComponent;